import React from 'react';

import { RaisedButton } from 'material-ui';
import { useDispatch, useSelector } from 'react-redux';
import { WHITE } from '../../config/colors';
import { checkOutUri } from '../../config/uri';
import {
  getDispensaryName,
  getLogoUrlLink,
} from '../../selectors/configSelectors';
import './style.css';
import { pushWithQueryParams } from '../../services/uri';

function Failure() {
  const secondaryColor = useSelector(state => state.config.secondaryColor);
  const dispensaryLogo = useSelector(state => getLogoUrlLink(state));
  const dispensaryName = useSelector(state => getDispensaryName(state));

  const dispatch = useDispatch();

  const returnToCart = () => dispatch(pushWithQueryParams(checkOutUri));

  return (
    <div className="failure-page">
      {dispensaryLogo && <img src={dispensaryLogo}/>}
      {!dispensaryLogo &&  <h1 className="dispensary-name-title">{dispensaryName}</h1>}
      <p className="failure-message">We’re sorry. Something went wrong in the checkout process. Please return to cart and try again.</p>
      
      <br/><br/>
      <RaisedButton
        backgroundColor={`#${secondaryColor}`}
        labelColor={WHITE}
        label="Return to Cart"
        labelStyle={{ fontWeight: 700 }}
        style={{ minWidth: '335px', margin: '0 auto'}}
        onClick={() => returnToCart()}
      />
    </div>
  );
}

export default Failure;


// WEBPACK FOOTER //
// ./src/components/Failure/Failure.jsx